/**
 * First-party page-view beacon for Ops → Insights → Traffic.
 * Sends only the path, the referring site and utm_source. No cookies, no
 * user ids, no query strings (except utm_source). Skips Ops/API pages and
 * respects Do Not Track / Global Privacy Control.
 */

const SKIP_RE = /^\/(ops|api|styleguide)(\/|$)/;

export const privacyOptOut = (nav = typeof navigator !== 'undefined' ? navigator : {}) =>
  nav.doNotTrack === '1' || nav.globalPrivacyControl === true;

export const buildPageViewPayload = ({ path, search = '', referrer = '', first = false }) => {
  const cleanPath = typeof path === 'string' ? path.split('?')[0].split('#')[0] : '';
  if (!cleanPath.startsWith('/') || SKIP_RE.test(cleanPath)) {
    return null;
  }
  let utm = '';
  try {
    utm = new URLSearchParams(search).get('utm_source') || '';
  } catch (e) {
    utm = '';
  }
  let ref = '';
  if (first && referrer) {
    try {
      const u = new URL(referrer);
      ref = `${u.protocol}//${u.host}/`;
    } catch (e) {
      ref = '';
    }
  }
  return { p: cleanPath, r: ref, u: utm.slice(0, 40), n: !!first };
};

export class SitePageViewHandler {
  constructor() {
    this.sentFirst = false;
  }

  trackPageView(canonicalPath) {
    if (typeof window === 'undefined' || privacyOptOut()) {
      return;
    }
    try {
      require('../util/bookingFunnel').trackBookingRoute(window.location?.pathname || '', window.location?.search || '');
    } catch (e) {
      // ignore
    }
    try {
      const tf = require('../util/talkerFunnel');
      const p = window.location?.pathname || '';
      const q = window.location?.search || '';
      if (!this.sentFirst) tf.trackAdLanding();
      const m = /^\/l\/(?:[^/]+\/)?([0-9a-f-]{36})(\/book)?\/?$/.exec(p);
      if (m && !m[2]) tf.trackTalkerFunnel('profile_view', { listingId: m[1], once: true });
      if (m && m[2] && /mode=now/.test(q)) tf.trackTalkerFunnel('talk_now_tap', { listingId: m[1], once: true });
      if (/^\/signup/.test(p)) tf.trackTalkerFunnel('signup_started', { detail: p.slice(7, 24) || null, once: true });
    } catch (e) {
      // ignore
    }
    const first = !this.sentFirst;
    this.sentFirst = true;
    const payload = buildPageViewPayload({
      path: window.location?.pathname || canonicalPath,
      search: window.location?.search || '',
      referrer: first ? document.referrer : '',
      first,
    });
    if (!payload) {
      return;
    }
    try {
      window
        .fetch('/api/pv', {
          method: 'POST',
          credentials: 'include',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
        .catch(() => {});
    } catch (e) {
      // Never break navigation for a count.
    }
  }

  trackEvent() {}
}
